import * as React from 'react';
import { Button, IconCall16 } from '@cian/ui-kit';
import { useSelector } from 'react-redux';

import { useCallbackButton } from './useCallbackButton';
import { useIsNewbuildingBrokerEntryRedesignEnabled } from '../../hooks/broker';
import { selectCallbackButtonTextExperimentActive } from '../../selectors/experiments';
import { getIsFlatViewOrderEnabled } from '../../selectors/newbuilding';
import { selectIsBrokerVisible } from '../../selectors/newbuildingBroker';

export function BasicCallbackButton() {
  const [isAvailable, handleClick, isLoading] = useCallbackButton('blockJK');
  const isNewbuildingBrokerEntryRedesignEnabled = useIsNewbuildingBrokerEntryRedesignEnabled();
  const isFlatViewOrderEnabled = useSelector(getIsFlatViewOrderEnabled);
  const isCallbackButtonTextExperimentActive = useSelector(selectCallbackButtonTextExperimentActive);
  const isBrokerVisible = useSelector(selectIsBrokerVisible);
  const isBrokerButtonVisible = isBrokerVisible && isNewbuildingBrokerEntryRedesignEnabled;
  // TODO: Занести выигравший text внутрь BasicCallbackButton в CD-190865.
  const buttonText = isCallbackButtonTextExperimentActive ? 'Заказ звонка' : 'Перезвоните мне';

  if (!isAvailable) {
    return null;
  }

  /*
   * В случае, если брокера доступна, то отображаем сокращенную кнопку ОЗ.
   */
  if (isBrokerButtonVisible) {
    return (
      <Button
        theme="fill_white_primary"
        size={'M'}
        beforeIcon={<IconCall16 color={'primary_100'} />}
        onClick={handleClick}
        loading={isLoading}
      />
    );
  }

  return isFlatViewOrderEnabled ? (
    <Button
      theme="fill_white_primary"
      size={'M'}
      beforeIcon={<IconCall16 color={'primary_100'} />}
      onClick={handleClick}
      loading={isLoading}
    />
  ) : (
    <Button theme="fill_white_primary" onClick={handleClick} loading={isLoading}>
      {buttonText}
    </Button>
  );
}
